var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM10 2.85714C10.789 2.85714 11.4286 3.49674 11.4286 4.28571V11.4286C11.4286 12.2176 10.789 12.8571 10 12.8571C9.21102 12.8571 8.57143 12.2176 8.57143 11.4286V4.28571C8.57143 3.49674 9.21102 2.85714 10 2.85714ZM10 17.1429C10.8679 17.1429 11.5715 16.5033 11.5715 15.7143C11.5715 14.9253 10.8679 14.2857 10 14.2857C9.13216 14.2857 8.42861 14.9253 8.42861 15.7143C8.42861 16.5033 9.13216 17.1429 10 17.1429Z",
    fill: "#F89500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/iconInfo.7f7c34535a23bd515726d94a7410c5e1.svg";
export { ForwardRef as ReactComponent };